var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-full min-h-screen"},[_c('site-header'),_c('div',{staticClass:"flex-grow bg-gray-50"},[_c('router-view')],1),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }